interface HeroContentProps {
  /** When true, render the "inside-the-lens" variant with flowing gradient text. */
  magnified?: boolean;
}

/**
 * Extracted so both the base layer and the magnified layer render EXACTLY the same
 * layout / flow. Keeping them identical is critical so the magnifier stays aligned.
 */
export default function HeroContent({ magnified = false }: HeroContentProps) {
  // Inside the lens, everything text-like uses a flowing rainbow gradient clipped to text.
  const gradientText = magnified ? "hero-lens-text" : "";

  return (
    <div className="relative z-10 w-full px-6 md:px-10 pt-32 pb-24 flex flex-col items-center text-center pointer-events-none">
      <p
        className={`text-xs md:text-sm tracking-wide mb-6 md:mb-8 ${
          magnified ? gradientText : "text-foreground-700"
        }`}
      >
        Invite-only summit for 100 Finance &amp; RevOps leaders
      </p>

      <h1
        className={`font-heading font-normal leading-[0.95] tracking-tight text-[64px] md:text-[104px] lg:text-[128px] ${
          magnified ? gradientText : "text-foreground-950"
        }`}
      >
        Sequence Collect
      </h1>

      <p
        className={`mt-8 md:mt-10 max-w-2xl text-sm md:text-base leading-relaxed ${
          magnified ? gradientText : "text-foreground-700"
        }`}
      >
        AI has cut the journey to $100M ARR from years to months. Learn how Finance &amp; RevOps
        leaders price, bill and collect in real time, and get your team ready for the new era
        of AI-native finance.
      </p>

      <p
        className={`mt-12 md:mt-14 text-xs md:text-sm font-mono tracking-wider ${
          magnified ? gradientText : "text-foreground-700"
        }`}
      >
        Sep 18, 2025 · San Francisco
      </p>

      <a
        href="#request"
        className={`pointer-events-auto mt-6 inline-flex items-center gap-2 transition-colors px-6 py-3 rounded-full text-sm font-medium cursor-pointer whitespace-nowrap ${
          magnified
            ? "hero-lens-cta text-background-50"
            : "bg-foreground-950 text-background-50 hover:bg-foreground-900"
        }`}
      >
        Request an invite
        <i className="ri-arrow-right-line text-base"></i>
      </a>
    </div>
  );
}